import ExcelIcon from '../../images/icon_excel.png'
import { Link } from 'react-router'

export const DownloadExplanationBox = () => {
  return (
    <div
      data-testid="downloadExplanationBox"
      style={{
        backgroundColor: 'var(--canvas-background-color--card)',
        border: '1px solid var(--canvas-background-color--placeholder)',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--canvas-spacing--normal)',
      }}
    >
      <span className="hc-fs-sm hc-mh-normal">
        <img
          style={{ height: 50, verticalAlign: 'middle', marginRight: '10px' }}
          src={ExcelIcon}
          alt="Microsoft Excel Icon"
        />
      </span>
      <span>
        {'Search for cost records on the '}
        <Link className="hesp-link" to="/cost-search">
          Cost Search page
        </Link>
        , download the results into an Excel file, enter any new costs into that
        Excel file, and then return to this page to upload your spreadsheet.
      </span>
    </div>
  )
}
